module.exports = "https://static.zego.com/_next/static/images/Tick-8d0e97ce2cc57a25368e4f685fb4e1ac.svg";